import { _js } from '@ifixit/utils/localize';
import { jsonBody, refusalMessage, webApiClient } from 'Shared/web_api_client';

// eslint-disable-next-line no-var
export var RelatedWikiForm = {
   initialize(form) {
      const wikiRelatedInputDiv = document.querySelector('#wikiRelatedInputDiv');

      document.querySelectorAll('.wikiRelatedFormToggle').forEach(element => {
         element.addEventListener('click', ev => {
            ev.preventDefault();
            ev.stopPropagation();
            wikiRelatedInputDiv.classList.toggle('hidden');
            const headerLink = document.querySelector('#wikiRelatedHeaderLink');
            if (headerLink) {
               headerLink.classList.toggle('hidden');
            }
         });
      });

      form.addEventListener('submit', async ev => {
         ev.preventDefault();
         ev.stopPropagation();
         const msgDiv = form.querySelector('.statusError');
         const data = new FormData(form);

         try {
            const client = await webApiClient();
            await client.put(
               `wikis/${data.get('relatedWikiid')}/related-device`,
               'wiki-related-device',
               jsonBody({ title: String(data.get('title') ?? '') })
            );
         } catch (error) {
            msgDiv.textContent =
               refusalMessage(error) ?? _js('Something went wrong. Please try again.');
            form.querySelector('input').blur();
            msgDiv.style.display = 'block';
            msgDiv.style.opacity = '1';
            setTimeout(() => {
               msgDiv.style.display = 'none';
            }, 3000);
            return;
         }
         window.location.reload();
      });
   },
};
